import { checkForAppUpdates } from "@/helpers/checkForAppUpdates";
import { onMounted, ref } from "vue";
import { Notification } from "element-ui";

export const useManageAppUpdates = () => {
  const installUpdateDialogVisible = ref(false);

  const reloadPage = () => {
    location.reload();
  };

  onMounted(() => {
    document.addEventListener(
      "visibilitychange",
      function () {
        document.dispatchEvent(
          new CustomEvent("appVisibilityChange", { detail: document.hidden })
        );
      },
      false
    );

    navigator.serviceWorker.addEventListener("message", (event) => {
      //If it is an update request, then update the app
      if (
        (event.data && event.data.title == "Check Update") ||
        (event.data.data && event.data.data.title == "Check Update")
      ) {
        checkForAppUpdates();
      }
    });

    document.addEventListener(
      "swUpdateFound",
      () => {
        Notification({
          title: "We are Updating",
          // type: "info",
          iconClass: "el-icon-loading mt-2",
          showClose: false,
          message: "Fetching new update now...",
        });
      },
      { once: true }
    );

    document.addEventListener(
      "swUpdated",
      () => {
        installUpdateDialogVisible.value = true;
      },
      { once: true }
    );
  });

  return { installUpdateDialogVisible, reloadPage };
};
